<div class="topHeader">
    <div class="container-fluid">
        <div class="upper_icon">
            <div class="position-relative">
                <!-- <i class="fa fa-bell notification_toggle" aria-hidden="true" (click)="notfication()"></i> -->
                <!-- <div class="navabr_dropdownTwo" *ngIf="isNotificationDropdown">
          <div class="navbar_dropdownTwoHead">
            <h5>Notification</h5>
            <div>10</div>
          </div>
          <div class="navbar_dropdownTwobellHeight">
            <div class="navbar_dropdownTwobell">
              <div class="round">
                <img src="../../../assets/media/logos/user_person.png" alt="">
              </div>
              <p>Micheal clarke upload new photo</p>
            </div>
            <div class="navbar_dropdownTwobell">
              <div class="round">
                <img src="./assets/media/logos/user_person.png" alt="">
              </div>
              <p>Micheal clarke upload new photo</p>
            </div>
            <button>See all notification</button>
          </div>
        </div> -->
            </div>

            <!-- <div class="position-relative" *ngIf="getAccountName() != ''">
        <a href="javascript:void(0)" [routerLink]="['/settings']"><i class="fa fa-cog" aria-hidden="true"></i></a>
      </div> -->

            <!-- <div class="position-relative">
        <i class="fa fa-user-circle user_toggle" aria-hidden="true" (click)="user()"></i>
        <div class="navbar_dropdownOne" *ngIf="isUserDropdown">
          <div class="settings_links mt-3" *ngIf="getAccountName() == ''">
            <a href="javascript:void(0)" class="btn font-weight-bold py-3 px-6" (click)="login()" i18n>login</a>
          </div>

          <div class="userProfile" *ngIf="getAccountName() !==''">
            <div class="round">
              <img src="../../../assets/media/logos/user_person.png" alt="">
            </div>
            <div class="settings_links mt-3" *ngIf="getAccountName() != ''">
              <h5>{{accountName}}</h5>
               <a href="javascript:void(0)" class="btn font-wei  ght-bold py-3 px-6" (click)="logout()" i18n>logout</a>
            </div>
            <h6>{{loggedInUserEmail}}</h6>
            <a href="avascript:void(0)" [routerLink]="['/user-profile']" class="me-1">
              <button class="btn primary-ebtn">Edit Profile</button>
            </a>
            <a href="javascript:void(0)" class="ms-1" *ngIf="getAccountName() !== ''">
              <button class="btn primary-ebtn" (click)="logout()">Sign out</button>
            </a>
            <div class="administration_links mt-5" *ngIf="isSystemAdmin">
              <a href="avascript:void(0)" [routerLink]="['/edit-organization',currentOrgId]">Administration</a>
            </div>
            <div class="bottom-section">
             <p><a href="javascript:void(0)">Privacy Policy</a> | <a href="javascript:void(0)">Terms of Service</a></p>
              <div class="organization_section" *ngIf="currentOrg">
                <div class="profile_img_div">
                  <ngx-avatars name="{{currentOrg}}" size="35"></ngx-avatars>
                </div>
                <div class="organization_name">
                  <p>{{currentOrg}}</p>
                  <a href="javascrip:void(0)">Log out</a>
                </div>
              </div>
              <div class="instance_section" *ngIf="currentInstance">
                <div class="profile_img_div">
                  <ngx-avatars name="{{currentInstance}}" size="35"></ngx-avatars>
                </div>
                <div class="instance_name">
                  <p>{{currentInstance}}</p>
                  <a href="javascrip:void(0)">Log out</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
        </div>
    </div>
</div>
